export var QuantizedScore;
(function (QuantizedScore) {
    QuantizedScore["BAD"] = "BAD";
    QuantizedScore["NEUTRAL"] = "NEUTRAL";
    QuantizedScore["GOOD"] = "GOOD";
    QuantizedScore["GREAT"] = "GREAT";
})(QuantizedScore || (QuantizedScore = {}));
function get_search_query(answered) {
    return "/search" + (answered ? "?" + answered.toURLParams(true).toString() : "");
}
export async function search(answered) {
    let url = get_search_query(answered);
    console.log("Fetch ...  " + performance.now());
    const req = await fetch(url);
    console.log("Fetch DONE " + performance.now());
    const data = await req.json();
    return data;
}
export async function search_ws(socket, answered) {
    let res = await socket.send(JSON.stringify({
        "type": "search",
        "args": answered != null ? Array.from(answered.toURLParams(true).entries()) : [],
    }));
    console.log("WS Response", performance.now());
    let data = JSON.parse(res);
    if (data.type !== "search") {
        throw `Unexpected message type from server: ${data.type}`;
    }
    return data.data;
}
export async function search_by_name_ws(socket, query) {
    let res = await socket.send(JSON.stringify({
        "type": "search_by_name",
        "query": query,
    }));
    let data = JSON.parse(res);
    if (data.type !== "search_by_name") {
        throw `Unexpected message type from server: ${data.type}`;
    }
    return data.data;
}
